import { forwardRef } from 'react';

import * as Separator from '@radix-ui/react-separator';

import { dividerRecipe } from './Divider.css';
import { getClassNames } from '../../util/css';
import { RecipeVariants } from '../../vanilla-extract.css';

type DividerProps = RecipeVariants<typeof dividerRecipe> & {
  className?: string;
  isDecorative?: boolean;
};

const sparkyDividerClassName = 'sparky-divider';

export const Divider = forwardRef<HTMLDivElement, DividerProps>(
  ({ weight = 'regular', emphasis = 'low', className, isDecorative = true }, ref) => {
    const classNames = getClassNames(sparkyDividerClassName, dividerRecipe({ weight, emphasis }), className);

    return <Separator.Root className={classNames} ref={ref} decorative={isDecorative} />;
  },
);

Divider.toString = () => `.${sparkyDividerClassName}`;
Divider.displayName = 'Divider';
